import React from 'react';
import PropTypes from 'prop-types';
import Button from '$components/Button';
import ExportGradesStatus from '$components/ExportGradesStatus';
import checkExportJobInProgress from '$utils/checkExportJobInProgress';
import { LastJob } from '$variables/types';

import {
  // Button,
  Container,
} from './ExportGradesButton.styled';

const stopPropagation = (event) => {
  event.stopPropagation();
};

const ExportGradesButton = ({
  onExportGrades,
  assessmentItemTitle,
  isDisabled,
  lastJob,
}) => {
  const { status } = lastJob || {};

  if (checkExportJobInProgress({ status })) {
    return (
      <Container onClick={stopPropagation}>
        <Button
          look="secondaryPurple"
          label={`exporting grades for ${assessmentItemTitle}`}
          disabled
        >
          Exporting...
        </Button>
      </Container>
    );
  }

  return (
    <Container onClick={stopPropagation}>
      <Button
        look="secondaryPurple"
        onClick={onExportGrades}
        label={`export grades for ${assessmentItemTitle}`}
        disabled={isDisabled}
      >
        Export grades
      </Button>
      <ExportGradesStatus exportJob={lastJob} />
    </Container>
  );
};

ExportGradesButton.propTypes = {
  onExportGrades: PropTypes.func.isRequired,
  assessmentItemTitle: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  lastJob: LastJob,
};

ExportGradesButton.defaultProps = {
  isDisabled: false,
  lastJob: undefined,
};

export default ExportGradesButton;
